import styled from 'styled-components';
export const StyledLegalNav = styled.ul.withConfig({ displayName: "StyledLegalNav", componentId: "sc-rd0ded" }) `
  display: flex;
  gap: ${(props) => props.theme.spacers.x3};
  margin: ${(props) => props.theme.spacers.x4} 0 ${(props) => props.theme.spacers.x8};
  list-style: none;
  padding: 0;
  justify-content: flex-end;
`;
export const StyledLegalNavListItem = styled.li.withConfig({ displayName: "StyledLegalNavListItem", componentId: "sc-1awwdn2" }) `
  ${(props) => props.theme.responsiveFontsize.body.medium}

  a {
    color: ${(props) => (props.isActive ? props.theme.colors.celticBlue : props.theme.colors.oxfordBlue)};
    text-decoration: none;

    &:hover {
      color: ${(props) => props.theme.colors.celticBlue};
    }
  }
`;
